// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"a510677f","678":"4f4b3204","963":"54a50475"}[chunkId] + ".chunk.js";
};